// ENV EXPORTS
export const ENV = process.env.REACT_APP_ENV
export const HOSTNAME = process.env.REACT_APP_HOSTNAME
export const AUTH_HOSTNAME = process.env.REACT_APP_AUTH_HOSTNAME
export const AUTHORIZATION_HOSTNAME =
  process.env.REACT_APP_AUTHORIZATION_HOSTNAME
export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID

export const AUTH_REDIRECT = `https://${HOSTNAME}/`
